import * as mainTerms from '../../mainTerms';

const adsetDef = mainTerms.Setting.adset.default;

const inventoryDef = mainTerms.Setting.inventory.default;
const impDef = mainTerms.Other.impression;
const audienceDef = mainTerms.Setting.audience.default;

export const adset = {
    title: adsetDef,
    name: {
        label: adsetDef + '명',
        placeholder: adsetDef + ' 이름을 입력하세요',
        error: {
            required: adsetDef + ' 이름을 입력해주세요',
            invalidHyphen: '광고 세트명에 하이픈 `-`을 이용하실 수 없습니다.',
        },
    },
    date: {
        label: adsetDef + ' 일정',
        placeholder: {
            begin: '시작일',
            end: '종료일',
        },
        description: adsetDef + '을 진행할 시작일과 종료일을 설정하세요.',
        error: {
            required: adsetDef + '을 진행할 시작일과 종료일을 설정해주세요.'
        },
    },
    targetInventory: {
        label: '대상 ' + inventoryDef,
        transfer: {
            source: '전체 ' + inventoryDef,
            target: '대상 ' + inventoryDef,
        },
        description: '광고를 노출시킬 ' + inventoryDef + '를 선택하세요.',
        error: {
            required: '광고를 노출시킬 대상 ' + inventoryDef + '를 선택해주세요.'
        },
    },
    status: {
        label: '노출 상태',
        column: {
            inactive: '비활성',
            active: '활성',
            emptyText: '선택된 ' + inventoryDef + '가 없습니다.',
            name: inventoryDef + ' 이름',
            status: '상태',
            explain: '설명',
        },
        description: inventoryDef+'별 노출 상태를 설정하세요.',
    },
    price: {
        label: '광고 단가',
        column: {
            emptyText: '선택된 ' + inventoryDef + '가 없습니다.',
            name: inventoryDef + ' 이름',
            type: '산정 방식',
            value: '가격',
            valuePresenting: '금액 표시'
        },
        error: {
            notZero: '무료가 아닐 경우, 단가를 0원으로 설정하실 수 없습니다.'
        },
        description: inventoryDef+'별 광고 단가를 설정하세요.',
    },
    budget: {
        label: '예산 방식',
        inactive: '통합 예산',
        column: {
            emptyText: '선택된 ' + inventoryDef + '가 없습니다.',
            name: inventoryDef + ' 이름',
            rate: '예산 비율',
            value: '예산',
            valuePresenting: '금액 표시',
        },
        active: inventoryDef+'별 일일 예산',
        error: {
            shouldBeSameBudget: '각 인벤토리 예산의 총합은 캠페인 예산과 같아야 합니다.',
        },
        description: '통합 혹은 ' + inventoryDef+'별로 예산을 지정할 수 있습니다.',
    },
    landingURL: {
        label: '연결할 주소',
        column: {
            emptyText: '선택된 ' + inventoryDef + '가 없습니다.',
            name: inventoryDef + ' 이름',
            landingURL: '연결할 주소'
        },
        error: {
            required: '랜딩 주소는 필수값입니다.',
        },
        description: `각 ${inventoryDef}들이 연결될 랜딩 주소를 입력하세요.\n랜딩 주소는 필수값이며, 트랙킹 주소는 옵션 값입니다.\n랜딩과 트래킹을 분리하고자 할 경우에만 사용하시면 됩니다. 그렇지 않을 경우에는 랜딩 주소만 사용하시기 바랍니다.`,
    },
    nativeInfo: {
        label: '네이티브 정보',
        title: {
            placeholder: '광고 타이틀',
            required: '타이틀을 지정해주세요.',
        },
        nativeDescription: {
            placeholder: '광고 설명',
            required: '설명을 지정해주세요.',
        },
        ctaText: {
            placeholder: '광고 CTA 문구',
            required: 'CTA 문구를 지정해주세요.',
        },
        column: {
            name: inventoryDef + ' 이름',
            title: '타이틀',
            nativeDescription: '설명',
            ctaText: 'CTA 문구',
        },
        description: '네이티브 광고 집행을 위한 정보를 입력할 수 있습니다.'
    },
    audience: {
        label: audienceDef,
        selectAudience: audienceDef + ' 선택하기',
        dialog: {
            title: audienceDef + ' 적용',
        },
        query: {
            placeholder: audienceDef + '이름',
        },
        description: '현재 광고가 대상으로 할 '+audienceDef+'를 설정할 수 있습니다.',
    },
    impressionSchedule: {
        label: impDef + ' 시간대',
        inactive: '비활성화',
        active: '활성화',
        description: '광고를 노출시킬 시간대를 직접 구성할 수 있습니다.',
    },
}